const eng = {
  aboutMe: "For more info about me",
  profile: "Profile",
  hiAdmin: "Hi Admin",
  username: "Username",
  password: "password",
  login: "Login",
  loginCap: "Login",
  signup: "signup",
  signupCap: "Sign up",
  pricesCap: "Prices",
  loginTitle: "Login to your account",
  signupTitle: "Sign up and start dancing!",
  email: "email",
  contactUs: "Contact",
  privacyPolicy: "Privacy Policy",
  termsOfUse: "Terms of Use",
  copyright: "All Contents Copyright © 2017-2021 Bailo.app",
  followUs: "FOLLOW US: fb, twitter, instagram",
  following: "Following",
  iLike: "I like",
  aboutUs: "About us",
  faq: "FAQ",
  downloadApp: "DOWNLOAD APP",
  withLove: "Made with ❤️ in Barcelona",
  homepage: "home",
  map: "Map",
  myBailo: "Lead",
  lead: "Lead",
  logout: "logout",
  titleMapdot: "title",
  ownerMapdot: "owner",
  addMapdot: "Add Bailo Dot",
  myBailoDotsFollow: "Bailo Dots I follow",
  myBailoDotsLead: "Venues I lead",
  noVenuesILead: "You don't have any venues to manage yet.",
  myMeetups: "Meetups I go to",
  myAdsLead: "Ads I lead",
  dance: "dance",
  category: "category",
  title: "title",
  description: "description",
  address: "address",
  addressPlus: "additional info",
  postalCode: "postal code",
  city: "city",
  country: "country",
  countryNotFound: "Country not found",
  searchCountry: "Search country",
  cityNotFound: "City not found",
  phoneNr: "phone number",
  emailMapdot: "professional email",
  website: "website",
  instagram: "Instagram",
  facebook: "Facebook",
  checkAddress: "Check Address",
  dayOfTheWeek: "day of week",
  sectionBasicData: "Basic Data",
  sectionLocation: "Location",
  sectionSchedule: "Schedule",
  day: "day",
  frequency: "frequency",
  dateStart: "date - start",
  dateEnd: "date - end",
  timeStart: "time - start",
  timeEnd: "time - end",
  price: "price",
  typeOf: "type",
  buttonAdd: "Add",
  venue: "milonga",
  practica: "practica",
  tango: "tango",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  once: "once",
  weekly: "weekly",
  fortnightly: "fortnightly",
  monthly: "monthly",
  editMapdot: "edit",
  reviewIt: "Review",
  editBailoDot: "Edit Bailo Dot",
  buttonUpdate: "update",
  buttonDelete: "delete",
  followLink: "follow bailo-dots",
  leadLink: "lead bailo-dots",
  addLink: "add bailo-dots",
  filterBy: "Filter by city",
  filterByMilongaName: "Search by name",
  search: "Search",
  filter: "Filter",
  admin: "Admin",
  adminAllBailoDots: "bailo-dots",
  adminPendingBailoDots: "pending bailo-dots",
  adminUsers: "Users",
  customerChat: "Customer Chat",
  danceRole: "dance role",
  statusUser: "status of the user",
  all: "all",
  approved: "approved",
  approve: "Approve",
  reject: "Reject",
  rejected: "rejected",
  onhold: "onhold",
  pending: "pending",
  userProfile: "user profile",
  numberOfLikes: "followers",
  activeSince: "active since",
  musicStyle: "music style",
  additionalInfo: "additionalInfo",
  statusMapdot: "status",
  imageMapdot: "image",
  yes: "yes",
  no: "no",
  realOwner: "Is it your Bailo Dot?",
  useReverseGeo: "use my location",
  locationAnswer: "location of bailo-dot saved",
  userLocation: "Location",
  createdBy: "created by",
  latitude: "latitude",
  longitude: "longitude",
  stars: "stars",
  note: "note",
  date: "date",
  meetups: "meetups",
  addMeetUp: "add a meetup",
  createdMeetups: "created meetups",
  attendMeetups: "attend meetups",
  editMeetUp: "edit meetup",
  userAbout: "About",
  userAboutMe: "About me",
  personalInformation: "Personal Information",
  unfriend: "Unfriend",
  friends: "Friends",
  block: "Block",
  unblock: "Unblock",
  cancelFriendship: "Cancel invitation",
  acceptFriendship: "Accept invitation",
  denyFriendship: "Deny invitation",
  social: "Social",
  shortInfo: "Info",
  reviews: "Reviews",
  noReviews: "No reviews yet",
  addReview: "Add review",
  goGoogle: "How to get there",
  capacity: "Capacity available",
  booking: "Booking",
  dateOfMeeting: "date of meeting",
  hasComments: "comments",
  participants: "participants",
  editProfile: "Edit profile",
  danceRoleLeader: "leader",
  danceRoleFollower: "follower",
  danceRoleBoth: "both",
  new: "New",
  repeat: "Repeat",
  settings: "Settings",
  editPassword: "Edit password",
  landingTitle: "Never ask again where to dance tonight",
  subTitleOne: "Find milongas, festivals, practicas, classes, concerts and live music worldwide.",
  subTitleTwo: "tango spaces and events published in +30 countries",
  seeMilongasNearMe: "See milongas near me",
  hideMilongasMap: "Hide map",
  downloadAppBtn: "Download app",
  statMilongasMapped: "+1,000 milongas mapped",
  statCountries: "+30 countries",
  statLanguages: "ES EN RU DE",
  organizerCtaTitle: "Do you organize tango events?",
  organizerCtaSubtitle: "List your milonga for free. Update it anytime and see real-time stats.",
  organizerCtaCheck1: "Reach dancers actively searching in your city",
  organizerCtaCheck2: "See real-time stats: visits, likes, contact clicks",
  organizerCtaCheck3: "Update your info anytime, no waiting",
  organizerCtaButton: "Publish my milonga — free",
  organizerCtaNote: "Free. No commitment. Access by link.",
  labelForDancers: "For dancers",
  labelForOrganizers: "For organizers",
  howItWorksLabel: "how it works",
  howItWorksSearch: "Search",
  howItWorksSearchText: "Your city or use your location",
  howItWorksFilter: "Filter",
  howItWorksFilterText: "Day, time, event type",
  howItWorksGoDance: "Go dance",
  howItWorksGoDanceText: "Save favorites, get notified",
  subTitleThree: "You can also register your own milonga.",
  subTitleFour:
    "Navigate, search for accommodation, and reach your final destination easily.",
  landingFeatureOne: "Constantly New Features",
  landingFeatureTwo: "Growing Tango Community",
  landingFeatureThree: "Easy to Use & For Free",
  landingFeatureOneText:
    "Continuous improvement is important to us and we highly appreciate your feedback.",
  landingFeatureTwoText:
    "There is a milonga missing on the map? Add it yourself or let us know and we do it!",
  landingFeatureThreeText:
    "Create o find your milonga in no time at home or during travels.",
  landingStory: "Our Story",
  landingStoryTextOne:
    "Our purpose is to create an international tango community with easy to find milongas worldwide.",
  landingStoryTextTwo:
    "Bailo.app was founded in 2017 under the name Tango Maps as a simple map with our favourite milongas, mainly in Barcelona, New Zealand, Israel, Italy and Córdoba, Argentina. We are both tango dancers and (what a surprise) met dancing the tango in Barcelona.",
  landingStoryTextThree:
    "Up until today, we have received positive feedback from tango dancers around the world who are passionate about tango and love travelling, meeting other tango addicts and enjoy some tango dances. More than a simple list of tango spots, Bailo.app is a constantly evolving online community.",
  landingStoryTextFour:
    "Bailo.app enjoys the tango with its traditions and also supports new movements, such as alternative tango music and gender/dance role swap.",
  landingMarceOne: "Tango addict since 2012",
  landingMarceTwo: "From Argentina",
  landingMarceThree: "Software Analyst & Web Developer",
  landingTashOne: "Tango addict since February 2006",
  landingTashTwo: "From Germany",
  landingTashThree: "Linguist & Web Developer",
  typeLetter: "type a letter",
  noResultsfound: "no results found",
  contactUsText:
    "Do you have any questions or feedback? Feel free to contact us via mail: bailo.app@gmail.com",
  bailoDots: "Bailo Dots",
  follow: "Follow",
  leadBailoDots: "Lead venues",
  leadMeetups: "Lead Meetups",
  addBailoDot: "Create",
  addMeetup: "Add Meetup",
  haveAnAccount: "Already have account?",
  keenTo: "Keen to",
  backTo: "Back to",
  class: "class",
  school: "school",
  teacher: "teacher",
  acceptTUPPOne: "I accept the",
  acceptTUPPTwo: "and",
  help: "Help",
  commonQuestions: "Common Questions",
  bailoYouTube: "Tango Court Métrage",
  bailoYouTubeText:
    "Searching for the best short videos that in some way talk about the tango. The rights of each video belong to each person who uploaded the video. Bailo.app simply promotes the world of the tango.",
  bailoBlog: "Bailo.app Blog",
  bailoBlogText: "Check out our latest Blog Post",
  bailoBlogHomepageTitle: "Homepage of our Blog",
  commonQuestionsTextLanding:
    "How do I add a milonga to the map? What is a Bailo Dot? These and other questions are answered in our common questions section. Let us know if you have any further questions",
  comments: "Comments",
  addComment: "Add Comment",
  userCommentUpdate: "Do you want to update your comment?",
  comment: "comment",
  finalDot: ".",
  analytics: "Analytics",
  notionLink: "Notion",
  siteAnalytics: "Site Analytics",
  sendPush: "Send Push",
  allSentPush: "Push History",
  sureSendPush: "Are you sure you want to send this push?",
  sureApproveIt: "Are you sure you want to approve it?",
  updateComment: "Edit your comment",
  cancelButton: "cancel",
  deleteComment: "Delete your comment",
  cancel: "cancel",
  spotsLeft: "spots left",
  thankYou: "Thank you",
  subscription: "Monthly gift in €",
  aLaGorra: "A la gorra",
  order: "One-time gift",
  amount: "amount",
  bailoSupport: "Feel free to support Bailo.app with your donation",
  donationTable: "Donation Table",
  planSupport: "Help in the way that suits you",
  yearlyDonation: "Annual donation",
  from: "from",
  plan1: "1€ monthly - La Yumba",
  plan2: "2€ monthly - Libertango",
  plan3: "5€ monthly - Farol",
  plan4: "10€ monthly - Poema",
  plan5: "15€ monthly - La cumparsita",
  planCli1: "La Yumba",
  planCli2: "Naranjo en flor",
  planCli3: "La cumparsita",
  paymentTitle:
    "Your donation helps keep the project alive. Thank you ever so much!",
  paymentTextOne: "The annual donation is automatic.",
  paymentTextTwo: "It may be cancelled at any time.",
  paymentTextThree: "This donation will be one time only.",
  paymentTextFour:
    "You shall be redirected to Buy Me a Coffee in order to confirm your donation.",
  paymentFive: "THANK YOU. GRACIAS. DANKE. MERCI.",
  donateBtn: "Donate via Buy Me a Coffee",
  empty: "",
  saveChanges: "Save Changes",
  closeButton: "Close",
  viewDetails: "View details",
  refNumber: "Your reference number: ",
  deleteMyUser: "Delete my user",
  publicName: "public name",
  dateOnce: "date",
  termsOfClass: "terms of class",
  classLevel: "level",
  offersOnlineLesson: "online lessons",
  offersPrivateLesson: "private lessons",
  sectionClassSchedule: "Class schedule",
  addClassSlot: "Add class",
  removeSlot: "Remove",
  selectSchool: "Link to school",
  selectTeacher: "Link to teacher",
  classTeacherName: "Teacher name",
  noClassSlots: "No classes added yet. Use the button below to add one.",
  sectionTeacherSchedule: "Teaching schedule",
  addTeacherScheduleSlot: "Add schedule",
  noTeacherScheduleSlots: "No schedule added yet. Use the button below to add one.",
  schoolName: "School (search or type freely)",
  infoAddBailoDot:
    "As soon as we approve your Bailo Dot, you can interconnect it with other Bailo Dots.",
  addSchool: "Link with your school",
  addNoSchool: "Do not link school / unlink",
  noSchoolFound: "no school found",
  linkedSchool: "Linked school",
  noSchoolLinked: "no linked school",
  addressAprox: "approximate location",
  noDescriptionYet: "no description yet",
  connections: "Connections with other Bailo Dots",
  addTeacher: "Link with a teacher",
  addNoTeacher: "Do not link teacher / unlink",
  noTeacherFound: "no teacher found",
  linkedTeacher: "Linked teacher",
  noTeacherLinked: "no linked teacher",
  share: "share",
  sureDelete: "Are you sure you want to delete your Bailo Dot?",
  leaveThisMeetup: "leave this Meetup",
  noNote: "without note",
  commentsGiven: "Comments given",
  updateImg: "Upload image",
  dropImg: "Drop files here",
  imgUpload: "image_upload",
  newMeetupCreated: "has created a new meetup for the",
  chatNotFound: "Chat Not Found",
  registerWithAdminTash: "Please, login with Admin Tash to answer this chat.",
  radio: "radio",
  musician: "artist",
  artist: "artist",
  artistType: "Artist type",
  artistTypeHint: "Write what type of artist you are. e.g. actor, singer, musician, DJ",
  liveMusic: "live music",
  festival: "festival",
  belongsToRadioStation: "radio station",
  belongsToPodcastPlatform: "podcast platform",
  languageSpokenRadio: "language spoken",
  radioWebsite: "radio website",
  linkWebsite: "link",
  buttonAddFriend: "Add to friends",
  friendRequests: "Friend requests",
  reportInfo: "Report error or confirm details",
  reportErrorDescription: "Error description",
  addVenueInfo: "Add / update venue info",
  addVenueInfoLabel: "Add or update details about this venue (e.g. schedule, music, notes)",
  reportLastConfirmation: "Last confirmation",
  reportNoConfirmation: "Not confirmed yet",
  confirmStatusGreen: "Info verified recently",
  confirmStatusYellow: "Verified 1+ month ago",
  confirmStatusRed: "Not yet verified",
  report: "Report",
  confirm: "Confirm",
  edit: "Edit",
  reportsTitle: "Reports",
  confirmTextOne: "Confirmed 🎉",
  confirmTextTwo: "You can now login via our app and website",
  confirmTextThree: "Download from the Apple Store",
  confirmTextFour: "Download from Google Play",
  confirmTextFive: "Login via our website",
  landingTryForFree: "Try Bailo.app for free!",
  sending: "Sending…",
  send: "Send",
  body: "body",
  googleSignup: "Sign up with Google",
  googleLogin: "Login with Google",
  facebookSignup: "Sign up with Facebook",
  facebookLogin: "Login with Facebook",
  dj: "dj",
  singer: "singer",
  orchestra: "orchestra",
  bandoneonist: "bandoneonist",
  guitarist: "guitarist",
  composer: "composer",
  quartet: "quartet",
  band: "band",
  musicianType: "musician - category",
  state: "state",
  county: "county",
  errorUsernameEmpty: "username is required",
  errorEmailEmpty: "email is required",
  errorEmailInvalid: "email is not valid",
  errorPasswordInvalid: "password is not valid",
  errorPasswordisLowercase: "add at least one lower case",
  errorPasswordisUppercase: "add at least one upper case",
  errorPasswordSpecialChars: "add at least one special character: #?!@$%^&*-",
  errorPasswordLength: "min 8 characters",
  errorPassword2Empty: "confirm password is required",
  errorPassword2Equals: "confirm password did not match",
  errorUsernameExist: "Username already exists",
  errorEmailExist: "Email already exists",
  passwordErrorInfo: "Password information",
  errorNotEmptyValues: "Fields not filled",
  passwordInfo:
    "Password: At least one upper case English letter, at least one lower case English letter, at least one digit, at least one special character (#?!@$%^&*-), minimum 8 in length",
  ads: "Ads",
  clientAd: "ad",
  addAd: "Add/Edit ad",
  leadAds: "Lead ads",
  here: "here",
  photoUpload: "Photo upload",
  adDescription: "tell us how do you want your ad",
  selectOption: "Select an option",
  bePartOfProject: "how to be part of this project",
  highlighted: "highlighted",
  events: "events",
  paymentOptions: "payment options",
  bannerSize: "Banner size",
  bannerDesign: "Banner design",
  bannerHighlight: "Banner highlighted",
  linkToClientWeb: "Link to your website",
  gifDesign: "Gif design",
  facebookDisution: "Facebook difusion",
  InstagramDifusion: "Instagram difusion",
  notificacionesPush: "Notification push",
  emailNotification: "Email notification",
  mapDotClient: "Geo marker in the map",
  mapdotDetailCli: "Detailed info about your event in Bailo.app",
  onMobileCli: "Your info in the mobile app",
  onWebCli: "Your info in the website",
  goGoogleCli: "How to get there via google maps",
  anualPriceCli: "Price (no taxes included)",
  getPlan: "get plan",
  taxes: "Taxes",
  list: "List",
  currentImg: "Current image",
  download: "Download",
  successAdMessage: "Your Ad was added!",
  successEditAdMessage: "Your Ad was edited correctly!",
  userRol: "User",
  adminRol: "Admin",
  adsNotFound: "You don't have any ads yet.",
  adsLevel2Required: "Available from Level 2",
  adsLevel3Required: "Available from Level 3",
  userLevel: "Level",
  analyticsLevelRequired: "Analytics available from Level 2",
  analyticsLevelRequiredDesc: "Upgrade your account to access venue analytics and track your performance.",
  adsLevelRequired: "Ads available from Level 3",
  adsLevelRequiredDesc: "Upgrade your account to manage ads and promote your venues.",
  levelLabel: "Level",
  levelUp: "Level up",
  levelDown: "Level down",
  confirmLevelUp: "Increase level for",
  confirmLevelDown: "Decrease level for",
  levelUpdated: "Level updated!",
  levelUpdateFailed: "Failed to update level",
  currentLevel: "Current level",
  details: "Details",
  priceDescription:
    "Start using the Bailo.app platform today and discover a new way to promote your tango product or service to the world.",
  whatsappContact:
    "Do you know a milonga that isn’t on Bailo.app yet? Drop us a message!",
  SendMessage: "Send a message",
  organizerCardTitle: "Do you organize tango events?",
  organizerCardSubtitle: 'Your space may already be listed on Bailo.app. <strong style="color:#22c55e;font-size:15px;font-weight:700">Claim it for free</strong>, keep it updated and see how dancers interact with it.',
  organizerCardBullet1: "Manage and publish your events",
  organizerCardBullet2: "Update schedules and details",
  organizerCardBullet3: "Add photos, links and location",
  organizerCardBullet5: "View real-time stats: visits, searches, likes and contact clicks",
  organizerCardBullet6: "Reach more dancers every day",
  manageMySpace: "Manage my space",
  organizerCardFooter: "Free. No commitment. Access link.",
  cardPerk1: "More visibility",
  cardPerk2: "More dancers",
  cardPerk3: "Real-time analytics",
  cardPerk4: "Totally free",
  growYourSpaceTitle: "Grow your space",
  growYourSpaceText1: "Invite your students and dancers to download Bailo.app, find your event and give it a like.",
  growYourSpaceText2: "The more likes and interactions your event has, the easier it will be to measure real interest.",
  loggedPerk1: "More visibility in searches",
  loggedPerk2: "More likes = more interest",
  loggedPerk3: "Better stats for you",
  loggedPerk4: "100% free",
  downloadSectionTitle: "Take tango with you wherever you go",
  downloadSectionSubtitle: "Download the app and find events near you, wherever you are.",
  downloadFeature1: "Live map of milongas near you",
  downloadFeature2: "Alerts when your next favorite is coming up",
  downloadFeature3: "Works in any city in the world, even while traveling",
  featureForDancers: "For dancers",
  featureForDancersText: "Find the best tango events near you in seconds. Anywhere in the world.",
  featureForOrganizers: "For organizers",
  featureForOrganizersText: "Keep your info updated, see real-time stats and reach more dancers every day.",
  featureWorldwideCommunity: "Worldwide community",
  featureWorldwideCommunityText: "A growing network of +1000 venues and tango lovers like you.",
  requestAccess: "Request access",
  requestAccessTitle: "Add or manage your tango space",
  requestAccessSubtitle: "For organizers only. If your space is already listed on Bailo.app, you can claim it. If it's not listed yet, you can create it for free.",
  requestAccessBullet1: "Update events and schedules",
  requestAccessBullet2: "See visits, likes and searches",
  requestAccessBullet3: "Free access by access link",
  requestAccessSent: "Request sent!",
  requestAccessSentDesc: "We have received your request. If approved, you will receive an access link by email within 24 hours.",
  businessType: "Business type",
  emailAddress: "Email address",
  selectBusinessType: "What do you organize?",
  businessTypeMilonga: "Milonga",
  businessTypeClass: "Tango class / school",
  businessTypeTeacher: "Teacher",
  businessTypeMusician: "Musician / orchestra",
  businessTypeFestival: "Festival / event",
  businessTypeOther: "Other",
  iAcceptThe: "I accept the",
  and: "and",
  somethingWentWrong: "Something went wrong. Please try again.",
  checkFormAndTryAgain: "Please check the form and try again.",
  alreadyHaveAccount: "Already have an account?",
  goHome: "Home",
  accessRequests: "Access Requests",
  resendMagicLink: "Resend Access Link",
  confirmResendMagicLink: "This will invalidate the current password and send a new access link to the user's email. Are you sure?",
  deleteUserForever: "Delete user permanently",
  confirmDeleteUser: "This will permanently delete the user and all their data. Their venues will be set to On Hold. This action cannot be undone. Are you sure?",
  userVenues: "Venues",
  adminUserDetail: "User Detail",
  usernameMaxChars: "Max 10 characters",
  addressOptional: "Address (optional)",
  dangerZone: "Danger zone",
  confirmDeleteMyAccount: "This will permanently delete your account and set all your venues to On Hold. This action cannot be undone. Are you sure?",
  profileUpdated: "Profile updated successfully!",
  changeAvatar: "Change avatar",
  chooseAvatar: "Choose avatar",
  savingLabel: "Saving…",
  noVenues: "No venues",
  noVenuesListTitle: "Nothing here yet! 🕺",
  noVenuesListMsg: "There are no venues for this day and filter. Try another day or category!",
  confirmedHeader: "confirmed",
  roleHeader: "role",
  makeAdmin: "Make admin",
  removeAdmin: "Remove admin",
  confirmMakeAdmin: "Grant admin privileges to",
  confirmRemoveAdmin: "Remove admin privileges from",
  roleUpdatedSuccess: "Role updated successfully",
  roleUpdateFailed: "Failed to update role",
  searchUsersPlaceholder: "Search by username or country…",
  noUsersFound: "No users found",
  fetchingLabel: "Loading...",
  resultsFound: "results found",
  usersLabel: "users",
  passwordUpdated: "Your password has been updated!",
  passwordMismatch: "Passwords do not match.",
  setFirstPasswordTitle: "Create your password",
  setFirstPasswordSubtitle: "Set a password to secure your account before continuing.",
  setFirstPasswordButton: "Save password & continue",
  magicLinkSent: "Access link sent!",
  failedToLoadUser: "Failed to load user",
  failedSendMagicLink: "Failed to send access link",
  userDeletedSuccess: "User deleted",
  failedDeleteUser: "Failed to delete user",
  verifyingLink: "Verifying your access link…",
  accessGranted: "Access granted!",
  redirectToSetPassword: "Redirecting you to set your password…",
  linkInvalid: "Link invalid",
  backToLogin: "Back to login",
  editUsernameTitle: "Edit username",
  festivalDateFrom: "From",
  festivalDateTo: "To",
  sectionFestivalDates: "Festival dates",
  adminEmptyListTitle: "Nothing here",
  adminEmptyListMsg: "No items match the current filter.",
  total: "Total",
  bulkImport: "Bulk Import",
  bulkImportTitle: "Paste JSON array",
  bulkImportSubtitle: "Paste an array of venue objects. Maximum 50 items.",
  bulkValidateBtn: "Validate JSON",
  bulkImportBtn: "Import venues",
  bulkResetBtn: "Reset",
  bulkErrorTitle: "JSON error:",
  bulkSummaryTitle: "Validation summary",
  bulkDetected: "detected",
  bulkValid: "valid",
  bulkWithErrors: "with errors",
  bulkReadyToImport: "Ready to import:",
  bulkFixErrors: "Fix these errors before importing:",
  bulkAllValid: "All venues are valid. Click \"Import venues\" to proceed.",
  bulkImportResultTitle: "Import result",
  bulkImportedOk: "venue(s) imported as pending.",
  bulkImportedFailed: "failed:",
  bulkFormatGuide: "Expected format",
  bulkFormatDesc: "An array of objects with these fields:",
  bulkValidCategories: "Valid categories:",
  bulkOptionalFields: "Optional fields:",
  bulkCheckingDuplicates: "Checking…",
  bulkDuplicateWarningTitle: "Possible duplicates found — review before importing:",
  bulkDuplicateExists: "Already exists:",
  bulkAllValidWithWarnings: "JSON is valid but some venues may already exist. Review the warnings above before importing.",
  bulkDuplicateConfirmTitle: "Possible duplicates detected",
  bulkDuplicateConfirmBody: "Some venues may already exist in the database. Do you want to import them anyway?",
  bulkDuplicateConfirmImport: "Import anyway",

  // Web feedback / user report
  webFeedback: "Contact us",
  webFeedbackTitle: "Report / Feedback",
  webFeedbackDesc: "Use this form to report bugs or suggest improvements to Bailo.app. Our team will review your message and respond via the notification bell.",
  webFeedbackMessage: "Your message",
  webFeedbackPlaceholder: "Describe the issue or improvement in detail…",
  webFeedbackAttachImage: "Attach image",
  webFeedbackChooseImage: "Choose image",
  webFeedbackRequired: "Please write a message before sending.",
  webFeedbackConfirm1Title: "Send report?",
  webFeedbackConfirm1Body: "Your report will be sent directly to the Bailo.app team. Do you want to continue?",
  webFeedbackConfirm2Title: "Are you sure?",
  webFeedbackConfirm2Body: "This will submit your report. We will review it and update you via the bell notification.",
  webFeedbackSendFinal: "Send report",
  webFeedbackSent: "Report sent successfully! We will review it shortly.",

  // Admin web feedback
  adminWebFeedback: "App Feedback",
  webFeedbackInProgress: "In progress",
  webFeedbackUpdateStatus: "Update status",
  webFeedbackAdminNote: "Note for user",
  webFeedbackAdminNotePlaceholder: "Brief note visible to the user…",
  webFeedbackViewImage: "View image",
  webFeedbackDeleteConfirm: "Are you sure you want to delete this report?",
  webFeedbackCleanupResolved: "Delete resolved",
  webFeedbackCleanupTitle: "Delete all resolved?",
  webFeedbackCleanupBody: "This will permanently delete all {n} resolved report(s), including attached images. This cannot be undone.",
  webFeedbackStatus_pending: "Pending",
  "webFeedbackStatus_in-progress": "In progress",
  webFeedbackStatus_resolved: "Resolved",
  webFeedbackStatus_rejected: "Rejected",

  // Notifications bell
  notifications: "Notifications",
  notificationsEmpty: "No notifications yet",
  notifMarkAllRead: "Mark all as read",

  // Misc
  optional: "optional",
  save: "Save",
  update: "Update",
  delete: "Delete",
  deleteConfirm: "Delete?",
  resolved: "Resolved",
  noResults: "No results found.",
};

export default eng;
